export default {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'Linkedin',
  twitter: 'Twitter',
  youtube: 'Youtube',
  'follow-instagram': '¡Síguenos en Instagram!',
  'share-on': 'Compartir en',
  flyers: 'Folletos y flyers',
  'business-cards': 'Tarjetas de visita',
  'books-magazines': 'Revistas, libros y catálogos',
}
